module.exports = __webpack_public_path__ + "static/media/3 02 Tulleord Sgo.a32d71c1.mp3";